import React from 'react'
import { Table,
  TableCell,
  TableHead,
  TableRow,
  Hidden,
  Typography,
  IconButton
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import RemoveRedEye from '@material-ui/icons/RemoveRedEye'

const styles = theme => ({
  compactTableCell:{
    padding: '0px 0px 0px 15px',
    "@media print": {
      padding: " 1px !important"
    }
  },
});

class DocHistoryDetails extends React.Component {

  render () {
    const {folio, link, to, from, classes, info} = this.props

    let historyDetails = <Typography className="no_print emptyTab">No hay historial</Typography>;

    if(((folio !== '') && (link !== '')) || (info.length > 0 && typeof info.length === 'number')){
      historyDetails = (
              <div>
                <Hidden only={['xs','sm']}>
                  <Table>
                    <TableHead>
                      <TableRow  align={"left"} style={{height:'30px'}}>
                        <TableCell className={classes.compactTableCell}>Folio</TableCell>
                        <TableCell className={classes.compactTableCell}>De</TableCell>
                        <TableCell className={classes.compactTableCell}>Para</TableCell>
                        <TableCell className={classes.compactTableCell} align={"left"}>Visualizar</TableCell>
                      </TableRow>
                    </TableHead>
                    <tbody>
                      {((folio !== '') && (link !== ''))?
                      <TableRow key={folio} style={{marginBottom: '1em', fontSize: '12px'}}>
                        <TableCell className={classes.compactTableCell} key={folio}  style={{width: '14%'}}>
                          {folio}
                        </TableCell>
                        <TableCell className={classes.compactTableCell} key={from}  style={{width: '14%'}}>
                          {from}
                        </TableCell>
                        <TableCell className={classes.compactTableCell} key={to}  style={{width: '14%'}}>
                          {to}
                        </TableCell>
                        <TableCell className={classes.compactTableCell} style={{width: '14%'}}>
                          <IconButton href={link} target="_blank">
                            <RemoveRedEye/>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      : null }
                      {
                        info.map(inf =>(
                          <TableRow key={inf.folio} style={{marginBottom: '1em', fontSize: '12px'}}>
                            <TableCell className={classes.compactTableCell} key={inf.folio}  style={{width: '14%'}}>
                              {inf.folio}
                            </TableCell>
                            <TableCell className={classes.compactTableCell} key={`${folio} from`}  style={{width: '14%'}}>
                              {`${typeof inf.from !== 'undefined'? inf.from : ''}`}
                            </TableCell>
                            <TableCell className={classes.compactTableCell} key={`${folio} to`}  style={{width: '14%'}}>
                              {`${typeof inf.to !== 'undefined'? inf.to : '' }`}
                            </TableCell>
                            <TableCell className={classes.compactTableCell} style={{width: '14%'}}>
                              <IconButton href={inf.link} target="_blank">
                                <RemoveRedEye/>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                          )
                        )
                      }
                    </tbody>
                  </Table>
                </Hidden>
              </div>
      );
    }


    return (historyDetails);
  }
}

export default withStyles(styles)(DocHistoryDetails);



// WEBPACK FOOTER //
// ./src/components/DocHistoryDetails.js